module.exports = __webpack_public_path__ + "img/comment.9ff5cff5.svg";